module.exports = __webpack_public_path__ + "img/write-message_dark.6160bc3b.svg";